import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/index/1-xl.avif")